module.exports = __webpack_public_path__ + "static/media/dochilove01.32d2c464.jpg";